import React from "react";
import PropTypes from "prop-types";
import ReviewItem from "../ReviewItem";
import styles from "./ReviewItemList.module.css";

export function ReviewItemList({ items, header, onReview }) {
  return (
    <div className={styles.container}>
      <span className={styles.header}>{header}</span>
      <div className={styles.reviewItemsContainer}>
        {items.map((item) => {
          return (
            <div className={styles.reviewItem} key={item.entityId}>
              <ReviewItem
                address={item.address}
                addressLabel={item.name}
                accountName={item.name}
                nameOnAccount={item.nameOnAccount}
                lastFour={item.lastFour}
                bankInfo={item.bankInfo}
                onReview={() => onReview(item.entityId)}
                bankRequired={item.bankRequired}
                w9Required={item.w9Required}
                emailStatus={item.emailStatus}
                addressStatus={item.addressStatus}
                w9Status={item.w9Status}
                achStatus={item.achStatus}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

ReviewItemList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      entityId: PropTypes.number.isRequired,
      address: PropTypes.shape({
        line1: PropTypes.string,
        line2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        postalCode: PropTypes.string,
      }).isRequired,
      name: PropTypes.string.isRequired,
      lastFour: PropTypes.string,
      bankInfo: PropTypes.object,
      bankRequired: PropTypes.bool.isRequired,
      w9Required: PropTypes.bool.isRequired,
      emailStatus: PropTypes.number,
      addressStatus: PropTypes.number,
      w9Status: PropTypes.number,
      achStatus: PropTypes.number,
    }).isRequired
  ).isRequired,
  header: PropTypes.string.isRequired,
  onReview: PropTypes.func.isRequired,
};

export default ReviewItemList;
